export type IGetRandomInteger = (min: number, max: number) => number;

export function getRandomInteger(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
